import { useTranslation } from "react-i18next";
import { useFormContext, useWatch } from "react-hook-form";
import { useQuery } from "@tanstack/react-query";
import React, { useMemo } from "react";
import { IFormValues } from "../../../../types";
import { InvoiceType, LegalFormCode, ReactQueryKey } from "../../../../../../types";
import { getLegalEntities } from "../../../../../../api/services";
import { FormAutocomplete } from "../../../../../../components/fields";

const LegalFormField = () => {
    const { t } = useTranslation('booking');

    const invoiceId = useWatch<IFormValues, "invoice.id">({
        name: 'invoice.id'
    });
    const invoiceType = useWatch<IFormValues, "invoice.type">({
        name: 'invoice.type'
    });
    const formContext = useFormContext<IFormValues>();

    const legalFormQuery = useQuery({
        queryKey: [ReactQueryKey.LegalForm],
        queryFn: getLegalEntities,
        refetchOnMount: false
    });

    const options = useMemo(() => {
        if (!legalFormQuery.data) {
            return []
        }

        if(invoiceType === InvoiceType.VAT_NUMBER_HOLDER) {
            const legalEntityVatNumber = legalFormQuery?.data?.find(elem => elem.code === LegalFormCode.DITTA_INDIVIDUALE);
            if (legalEntityVatNumber) {
                formContext.setValue('invoice.legalEntity', legalEntityVatNumber);
            }
            return [legalEntityVatNumber];
        } else {
            return legalFormQuery?.data?.filter(elem => elem.code !== LegalFormCode.DITTA_INDIVIDUALE);
        }
    }, [
        invoiceType,
        legalFormQuery.data
    ]);

    return (
        <FormAutocomplete<IFormValues>
            name="invoice.legalEntity"
            label={t('label.legalForm')}
            options={options ?? []}
            isOptionEqualToValue={(option, value) => option.code === value.code}
            getOptionLabel={(option) => { return !!option.label ?  t(`legalForms.${option.label}`) : ''}}
            disabled={!!invoiceId || invoiceType === InvoiceType.VAT_NUMBER_HOLDER || formContext.getValues('invoice.linkedToBusinessAgreement')}
        />
    )
}

export default LegalFormField;
